var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcons8Soundcloud(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "144px",
    height: "144px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF5722",
    d: "M10 33.018c.596 0 1.265 0 2 0V19.041c-1.11 1.001-1.699 2.212-2 3.121V33.018zM21 18.105c-.675-.316-1.752-.715-3-.837v15.749c.976 0 1.98 0 3 0V18.105zM14 33.018c.943 0 1.95 0 3 0V17.24c-1.173.03-2.171.23-3 .558V33.018zM4 23.953c-1.178.896-2 2.35-2 4.039 0 1.586.795 2.987 2 3.905V23.953zM40.995 22.016c-1.444 0-2.283.521-2.283.521s-.839-8.488-9.271-8.488c-4.906 0-6.83 2.704-7.441 3.897v15.071c8.825 0 18.297 0 18.297 0s5.869-.094 5.869-5.453C46.166 23.439 42.439 22.016 40.995 22.016zM8 23.1c-.395-.051-.842-.088-1.341-.088-.223 0-.441.037-.659.073v9.767c.423.104.861.166 1.311.166.151 0 .393 0 .689 0V23.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Soundcloud);
export default __webpack_public_path__ + "static/media/icons8-soundcloud.ddebf2cd9e53b3ebd0d7cd7c1853d1d8.svg";
export { ForwardRef as ReactComponent };